<template lang="html">
  <div class="product-list">
    <div class="container">

      <h2 class="list-title" v-if="title" v-html="title"></h2>

      <p>
        <em>Please note: The customers cart and your product categories will be visible on your page at all times as it will be floating at the bottom of the screen. We were unable to mimick this behaviour in the widget previewer, but you can see it directly below.</em>
      </p>

      <hr>

      <div :class="`item-count-${totalQty}`">
        <div
          :class="[
            'product-list-options',
            `${activeOption}-active`,
            {'is-active': productOptionsActive}
            ]">
          <div class="container">
            <div class="options-inner">
              <OrderForm
                v-if="!contacted"
                :lineItems="lineItems"
                :totalQty="totalQty"
                :totalPrice="totalPrice"
                :currency="currency"
                @submit="sendMessage"
                @activateOrderForm="activateType"
                @updateQuantity="updateQuantity"
                @removeFromCart="removeFromCart"
                v-model="contact"/>

              <ProductListFilter
                :categories="categories"
                @activateFilters="activateType"
                />
            </div>
          </div>
        </div>
      </div>

      <hr>

      <div v-for="category in categories" :key="category">
        <span
          class="category-anchor"
          :id="`product-category-${category.toLowerCase()}`">
        </span>

        <h2 class="list-title" @click="highlightField('product category')">{{category}}</h2>

        <ProductListProduct
          :demoMode="demoMode"
          v-for="(item, index) in products(category)"
          @addToCart="addToCart"
          @highlightField="highlightField"
          :product="item"
          :key="`product-${index}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

import notification from '@/mixins/notification'
import parseComponent from '@/mixins/parseComponent'

import ProductListProduct from './ProductListProduct'
import ProductListFilter from './ProductListFilter'
import OrderForm from './OrderForm'

export default {
  name: 'product-list',

  props: ['items', 'title', 'demoMode'],

  mixins: [parseComponent, notification],

  data() {
    return {
      contact: {},
      contacted: false,
      categories: [],
      lineItems: [],
      productOptionsActive: false,
      activeOption: ''
    }
  },

  components: {
    ProductListProduct,
    ProductListFilter,
    OrderForm
  },

  computed: {
    ...mapState(['route']),
    ...mapGetters(['siteId']),

    messageParams() {
      return {
        message: this.contact
      }
    },

    products() {
      return (category) => {
        return this.items.filter(
          product => this.parse(product).product_category.toLowerCase() === category.toLowerCase()
        )
      }
    },

    currency() {
      let item = this.items[0]
      return this.parse(item).product_currency || '£'
    },

    totalQty() {
      let qty = 0

      this.lineItems.forEach((item) => {
        qty += parseInt(item.qty)
      })

      return qty
    },

    totalPrice() {
      let price = 0

      this.lineItems.forEach((item) => {
        price += parseFloat(item.price).toFixed(2) * parseInt(item.qty)
      })

      return price
    }
  },

  methods: {
    setCategories() {
      let products = this.items
      let categories = []

      if (products) {
        products.forEach((product) => {
          if (this.parse(product).product_category === null) {
            categories.push('uncategorised')
          } else {
            categories.push(this.parse(product).product_category)
          }
        })

        this.categories = [...new Set(categories)]
      }
    },

    highlightField(value) {
      this.$emit('highlightField', value)
    },

    addToCart(title, currency, price, category, qty, image) {
      let cat = category || ''

      let alreadyInCart = this.lineItems.filter(item => item.title === title).length > 0

      if (alreadyInCart) {
        this.lineItems.find((item) => {
          if (item.title === title) {
            const currentQty = parseInt(item.qty)
            item.qty = currentQty + parseInt(qty)
          }
        })
      } else {
        this.lineItems.push({title, currency, price, cat, qty, image})
      }
    },

    activateType(type) {
      if (this.activeOption === type) {
        this.activeOption = ''
        this.productOptionsActive = false
      } else {
        this.activeOption = type
        this.productOptionsActive = true
      }
    },

    removeFromCart(product) {
      this.lineItems = this.lineItems.filter((prod) => {
        return prod !== product
      })
    },

    updateQuantity(qty, item) {
      let product = this.lineItems.find(product => product === item)
      product.qty = qty
    },

    sendMessage() {
      alert('You will recieve customer and order details via email.')
    }
  },

  mounted() {
    this.setCategories()
  },

  watch: {
    'this.items'() {
      this.setCategories()
    }
  }
}
</script>

<style lang="sass">
  @import '../../../stylesheets/base/variables'
  @import '../../../stylesheets/helpers/mixins'

  $max-height: 90vh

  .product-list
    .category-anchor
      visibility: hidden
      position: absolute
      margin-top: -85px

    .responsive-image img
      height: 100%

    .overlay
      .inner
        max-width: 500px

      p, h2
        text-align: center

  .close-form
    opacity: 0
    transition: opacity .3s ease-in-out

  .product-list-options
    z-index: 500
    transition: transform .3s ease-in-out

    &.is-active
      .close-form
        opacity: 1

    .container
      margin: 0 auto
      max-width: 750px
      padding-bottom: 0
      position: relative

    .btn
      margin: 0

    &.order-form-active
      .order-form
        max-height: $max-height

    &.filters-active
      .product-list-filter
        max-height: $max-height

    .options-inner
      display: flex
      flex-direction: column
      background: #fff
      border-radius: 5px
      transition: all .3s ease-in-out
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.4)

  .toggle-btn
    width: 100%
    border-radius: 0!important
</style>
